import type { SingleEnvironmentConfig } from './SingleEnvironmentConfig';

async function loadEnvConfig(env: string): Promise<SingleEnvironmentConfig> {
    return (await import(`./configs/${env}.ts`)).default;
}

export { loadEnvConfig };
